import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FamilyInviteWizard } from '../../../components/generic'
import { SectionHeader } from '../../../components/generic'
import { sizes } from '@lmc/common/constants'
export class FamilyInviteScreen extends Component {
  render() {
    const { preferredPeopleNominative } = this.props
    if (!preferredPeopleNominative) return null

    // Residents -> resident
    const preferredTerm = preferredPeopleNominative.slice(0, -1).toLowerCase()

    return (
      <div style={styles.container}>
        <SectionHeader title={'Invite Family Members'} />
        <p style={styles.subtitle}>
          Once you know a {preferredTerm} is happy to share their information
          and a family member is interested in the App, you can start inviting
          them straight away.
        </p>
        <FamilyInviteWizard />
      </div>
    )
  }
}

FamilyInviteScreen.propTypes = {
  preferredPeopleNominative: PropTypes.string,
}

const styles = {
  container: {
    margin: '0 auto',
    marginBottom: 50,
    marginTop: 55,
    maxWidth: sizes.childScreen,
  },
  subtitle: {
    marginBottom: 20,
  },
}

const mapStateToProps = (state) => ({
  preferredPeopleNominative: state.global.home.preferredPeopleNominative,
})

export default connect(mapStateToProps)(FamilyInviteScreen)
